import { Reveal, SectionHeading } from "@/components/Reveal";
import { CHAPTERS, IMAGES } from "@/data/content";

const ChiSiamo = () => (
  <section id="chi-siamo" data-testid="chi-siamo-section" className="relative py-24 sm:py-36">
    <div className="mx-auto grid max-w-7xl gap-16 px-5 sm:px-8 lg:grid-cols-2 lg:gap-24">
      <div className="min-w-0">
        <SectionHeading
          chapter="01"
          eyebrow="Chi Siamo"
          title="Mettere al centro la persona"
          text="Orto della Longevità è un complesso residenziale dedicato al benessere della persona, immerso nel verde e progettato per offrire serenità, comfort e qualità della vita."
          testid="chi-siamo-heading"
          hint="chi-siamo-scroll-hint"
        />
        <div className="mt-8 flex touch-pan-x snap-x snap-mandatory gap-4 overflow-x-auto pb-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden lg:mt-14 lg:touch-auto lg:flex-col lg:gap-12 lg:overflow-visible lg:pb-0">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.1} className="w-[72%] shrink-0 snap-start lg:w-full">
              <div className="flex aspect-square flex-col gap-3 rounded-[2rem] border border-sand bg-card p-6 shadow-sm lg:aspect-auto lg:h-full lg:flex-row lg:gap-6 lg:rounded-none lg:border-0 lg:border-l lg:bg-transparent lg:p-0 lg:pl-6 lg:shadow-none" data-testid={`chapter-${c.num}`}>
                <span className="font-serif text-4xl italic text-terracotta/70 leading-none">{c.num}</span>
                <div>
                  <h3 className="font-serif text-2xl font-medium text-ink">{c.title}</h3>
                  <p className="mt-2 text-[13px] leading-relaxed text-moss lg:mt-3 lg:text-sm">{c.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="relative min-w-0">
        <Reveal className="lg:sticky lg:top-28">
          <div className="relative">
            <div className="overflow-hidden rounded-[2.5rem] rounded-tr-none">
              <img
                src={IMAGES.chiSiamo}
                alt="Il parco con la fontana di Orto della Longevità"
                className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-105 lg:aspect-[4/5]"
                loading="lazy"
              />
            </div>
            <div className="absolute -bottom-8 left-4 max-w-[80%] rounded-3xl bg-sage p-6 shadow-2xl shadow-sage/30 sm:max-w-xs lg:-left-8 lg:p-7" data-testid="chi-siamo-quote">
              <p className="font-serif text-2xl italic leading-snug text-ivory">“Dove il tempo ha ancora valore.”</p>
              <p className="mt-3 text-[11px] uppercase tracking-[0.25em] text-ivory/60">La nostra filosofia</p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default ChiSiamo;
